import { Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material'
import { useEffect, useState } from 'react'
import SingleCategoryTab from './SingleCategoryTab'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import styles from './budgetTrackerStyle.module.scss'
import { useDispatch } from 'react-redux'
import { getCategoryLineItems } from '../../features/kazooEventSlice'
import { useParams } from 'react-router-dom'

const CategoryTab = () => {
    const dispatch = useDispatch()
    const { kazooId } = useParams()

	const [value, setValue] = useState(0)
	const handleChange = (e, newValue) => {
		setValue(newValue)
	}
	const tabs = [
        ['Photography/Videographer'],
        ['Attire'],
        ['Music'],
        ['Venue'],
        ['Caterer'],
        ['Officiant'],
        ['Entertainment'],
        ['Planner/Coordinator'],
        ['Transportation'],
        ['Aesthetics'],
        ['Lighting/AV'],
        ['Photo Booth'],
        ['Accommodations'],
        ['Stationery/Invitations'],
        ['Decor/Rentals'],
        ['Florist'],
        ['Baker (Cakes/Desserts)'],
        ['Tips'],
        ['Miscellaneous'],
    ]

	const isSmallScreen = useMediaQuery('(max-width:1199px)')

    useEffect(() => {
        dispatch(getCategoryLineItems(kazooId))
    }, [dispatch])

	return (
		<>
			<div className={styles.categoryTabWrp}>
				<Grid container alignItems={'unset'}>
					<Grid size={{ xs: 12, lg: 2.5 }}>
						<div className={styles.categoryLeft}>
							<Typography
								variant="h3"
								className={styles.cardTitle}
							>
								Category
							</Typography>
							<Tabs
								value={value}
								onChange={handleChange}
								orientation={
									isSmallScreen ? 'horizontal' : 'vertical'
								}
								variant='scrollable'
								scrollButtons={isSmallScreen ? 'auto' : false}
								allowScrollButtonsMobile={isSmallScreen}
								aria-label="scrollable force tabs example"
								sx={{
									'& .MuiTabs-scrollButtons.Mui-disabled': {
										opacity: '0.3',
									},

									'& .MuiTabs-indicator': {
										display: 'none',
										left: '0',
										right: 'auto',
										backgroundColor: '#7CA6BD',
									},
									'& .MuiButtonBase-root': {
										fontFamily: 'Inter',
										fontSize: '14px',
										fontWeight: '600',
										color: '#313131',
										textAlign: 'left',
										padding: '10px 14px',
										border: '1px solid #DFE4EB',
										borderRadius: '8px',
										margin: '4px',
										'&.Mui-selected': {
											backgroundColor: '#F2F6F8',
											border: '1px solid #7CA6BD',
											color: '#7CA6BD',
											'& svg path': {
												stroke: '#7CA6BD',
											},
										},
									},
									'@media (max-width: 1199px)': {
										minHeight: 'unset',
										height: 'unset',
										maxHeight: 'unset',
										'& .MuiButtonBase-root': {
											padding: '6px 10px',
										},
									},
                                    
                                    height: "300px"
								}}
							>
								{tabs.map((data, index) => {
									return (
										<Tab
											key={index}
											sx={{
												textTransform: 'none',
												minHeight: 'unset',
												justifyContent: 'start',
											}}
											icon={data[0]}
											iconPosition="start"
											disableRipple
											label={
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent:
															'flex-end',
														width: '100%',
													}}
												>
													{value === index && (
														<ChevronRightIcon
															sx={{
																color: '#7CA6BD',
																fontSize:
																	'20px',
																marginLeft:
																	'8px',
																'& path': {
																	stroke: '#7CA6BD',
																	strokeWidth: 1,
																},
															}}
														/>
													)}
												</div>
											}
										/>
									)
								})}
							</Tabs>
						</div>
					</Grid>
					<Grid size={{ xs: 12, lg: 9.5 }}>
						<div className={styles.categoryRight}>
							<SingleCategoryTab 
                                title={tabs[value][0]}
                            />
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default CategoryTab
